import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const JobProfileRightWrapper = styled.div`
  display: flex;
  flex: 1;
  margin: 10px;
  flex-direction: column;
  padding: 10px 20px;

  ${mediaMaxWidth.smallDesktop`
    width: 455px;
    flex: unset;
  `}

  ${mediaMaxWidth.phone`
    width: calc(100vw - 20px);
    margin: 5px 10px;
  `}
`;

export const Inner = styled.div`
  background-color: #402680;
  border-radius: 8px;
  margin: -10px -20px;
  padding: 10px 20px;
  box-shadow: 0 0 15px #dcdcdc;
`;

export const Section = styled.div`
  iframe {
    width: 100%;
    height: 350px;
    border: none;
    z-index: 0;

    .mapDiv {
      border-radius: 8px;
    }
  }
`;

export const SectionHeader = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #fff;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  margin: 7px 0;
  display: flex;

  ${mediaMaxWidth.tablet`
    font-size: .85em;
  `}
`;

export const SectionContent = styled.div`
  font-size: ${(props) => (props.large ? "2em" : "1em")};
  padding: ${(props) => (props.large ? "0px 10px" : "5px 10px")};
  line-height: 1.6em;
  margin-bottom: 10px;
  color: #fff;

  ${mediaMaxWidth.phone`
    font-size: ${(props) => (props.large ? "1.5em" : "0.875em")};
  `}
`;

export const MultiSection = styled.div`
  display: flex;
  flex-direction: row;

  ${mediaMaxWidth.phone`
    flex-direction: column;
  `}
`;

export const MutiSectionItem = styled.div`
  display: flex;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const MapPlaceholder = styled.div`
  min-height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% + 40px);
  margin-left: -20px;
  position: relative;
`;
